import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { popularKeywords, siteInfo } from '@/mocks/site';

const stats = [
  { value: '8 个', label: '精选专题' },
  { value: '24 篇', label: '深度整理' },
  { value: '6 大', label: '主题分类' },
  { value: '每日', label: '持续更新' },
];

export default function HeroSection() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/library?q=${encodeURIComponent(q)}` : '/library');
  };

  return (
    <section className="relative w-full min-h-[560px] md:min-h-[640px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Moody%20warm%20editorial%20photograph%20of%20crumpled%20kraft%20paper%20and%20folded%20newspapers%20on%20a%20dark%20walnut%20table%2C%20dramatic%20amber%20side%20light%2C%20deep%20shadows%2C%20rich%20burnt%20orange%20highlights%2C%20abstract%20texture%2C%20cinematic%20magazine%20aesthetic&width=1600&height=900&seq=kanliao-hero-01&orientation=landscape"
        alt="看料社热门专题资源库主视觉背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60" />

      <div className="relative z-10 w-full max-w-content mx-auto px-4 md:px-6 pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="max-w-3xl">
          <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 text-background-50 text-xs md:text-sm mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse" />
            热点专题 · 全集完整版 · 系列持续更新
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
            在线看料
            <span className="block mt-2 text-accent-400">资源库全集完整版</span>
          </h1>
          <p className="mt-6 text-sm md:text-base text-background-100/90 leading-relaxed max-w-2xl">
            {siteInfo.slogan}。热门爆料事件深度整理，合集持续更新，想看哪部点哪部，一个入口补齐所有来龙去脉。
          </p>

          <form onSubmit={submit} className="mt-8 max-w-xl" data-no-form>
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="relative flex-1">
                <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500 text-base" />
                <input
                  type="text"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索专题、关键词，例如：综艺名场面"
                  className="w-full pl-11 pr-4 py-3.5 rounded-md bg-background-50 text-foreground-950 text-sm placeholder:text-foreground-500 outline-none focus:ring-2 focus:ring-accent-400/60"
                />
              </div>
              <button
                type="submit"
                className="px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                搜索专题
              </button>
            </div>
          </form>

          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="text-xs text-background-100/70">热门搜索：</span>
            {popularKeywords.slice(0, 5).map((k) => (
              <button
                key={k}
                type="button"
                onClick={() => navigate(`/library?q=${encodeURIComponent(k)}`)}
                className="px-3 py-1 rounded-full text-xs border border-background-50/25 text-background-100/90 hover:bg-background-50/15 transition-colors cursor-pointer whitespace-nowrap"
              >
                {k}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl">
          {stats.map((s) => (
            <div key={s.label} className="border-l-2 border-accent-500/70 pl-4">
              <p className="font-heading text-xl md:text-2xl font-bold text-background-50">{s.value}</p>
              <p className="text-xs md:text-sm text-background-100/80 mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}